export default __webpack_public_path__ + "static/media/dejan_xl.f378ee18.jpg";